module.exports = __webpack_public_path__ + "media/images/ig-posts-ff5605cd954ce8b617946b2f2dae1186.png";